module.exports = __webpack_public_path__ + "static/img/Bestatter-logo.fc7ecbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bestatter-logo.png
// module id = qpYN
// module chunks = 1